import React from 'react';
import { connect } from 'react-redux';
import { submit } from 'redux-form';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const RemoteSubmitButton = ({ dispatch, formName, label, style, icon, ...rest }) => {
	let iconComponent;
	let divider;
	if (icon) {
		iconComponent = <FontAwesomeIcon icon={icon} />;
		divider = ' ';
	}

	return <Button bsStyle={style} onClick={() => dispatch(submit(formName))} {...rest}>
		{iconComponent}
		{divider}
		{label}
	</Button>;
};

export default connect()(RemoteSubmitButton)